import React from 'react';
import { FlameIcon } from 'lucide-react';
import type { MenuCategory } from '../types/menu';
type MenuCategoryBlockProps = {
  category: MenuCategory;
};
export function MenuCategoryBlock({
  category
}: MenuCategoryBlockProps) {
  return <section id={category.id} aria-labelledby={`${category.id}-heading`} data-id="element-27" data-mp="2qpy0u7gru8ck">
      <div className="pb-[clamp(0.75rem,1vw,2.5rem)]" data-id="element-28" data-mp="2lrd086xlxmnl">
        <h3 id={`${category.id}-heading`} className="fs-h3 text-gold-gradient inline-block pb-[0.05em] font-display font-bold leading-tight" data-id="element-29" data-mp="2gtbgrkw9rlbl">
          {category.title}
        </h3>
        {category.description && <p className="fs-sm mt-[0.3em] max-w-[60em] italic leading-relaxed text-muted" data-id="element-30" data-mp="27togj2fa0lk4">{category.description}</p>}
      </div>
      <div className="h-px w-full bg-gradient-to-r from-gold via-gold/40 to-transparent" aria-hidden="true" data-id="element-31" data-mp="22vmxghhuom8n" />

      <ul className="mt-[clamp(1.5rem,2vw,4.5rem)] grid grid-cols-1 gap-x-[clamp(2rem,4vw,10rem)] gap-y-[clamp(1.25rem,1.6vw,4rem)] md:grid-cols-2 3xl:grid-cols-3" data-id="element-32" data-mp="5yxizwug5itt">
        {category.items.map(item => <li key={item.name} className="flex min-w-0 flex-col" data-id="element-33" data-mp="39ag25fasa7rr">
            <div className="fs-item flex items-baseline" data-id="element-34" data-mp="39br4daokz7gr">
              <h4 className="flex flex-wrap items-center gap-x-[0.5em] gap-y-1 font-label font-medium uppercase leading-snug tracking-[0.12em] text-cream" data-id="element-35" data-mp="2vbgd46jczqv2">
                {item.name}
                {item.spicy && <FlameIcon className="h-[0.95em] w-[0.95em] text-copper" aria-label="Spicy" data-id="element-36" data-mp="3nz3ulcpc21dh" />}
                {item.popular && <span className="fs-tag rounded-full border border-gold/80 px-[0.8em] py-[0.2em] font-label font-medium uppercase tracking-[0.18em] text-gold-light" data-id="element-37" data-mp="3s0fo3tbbv6qy">
                    Favorito
                  </span>}
              </h4>
              <span className="mx-[0.75em] min-w-[1.5em] flex-grow translate-y-[-0.25em] border-b border-dotted border-gold/50" aria-hidden="true" data-id="element-38" data-mp="asaetlyetvqr" />
              <span className="text-gold-gradient whitespace-nowrap font-label font-medium tracking-[0.06em]" data-id="element-39" data-mp="pg2fcojp7rqs">
                {item.price}
              </span>
            </div>
            {item.description && <p className="fs-sm mt-[0.3em] leading-relaxed text-muted" data-id="element-40" data-mp="fgtow5o1kv96">{item.description}</p>}
            {item.options && <p className="fs-sm mt-[0.3em] font-normal text-gold-light/90" data-id="element-41" data-mp="aj1mghprtqqq">{item.options}</p>}
          </li>)}
      </ul>

      {category.notices && <div className="fs-sm mt-[clamp(1.5rem,2vw,4.5rem)] rounded-[clamp(0.75rem,0.8vw,1.75rem)] border-l-2 border-gold bg-panel px-[1.4em] py-[1em]" data-id="element-42" data-mp="6ihr9jorcx78">
          {category.notices.map(n => <p key={n} className="text-cream" data-id="element-43" data-mp="3stwqxp2n5y8s">
              {n}
            </p>)}
        </div>}
    </section>;
}